module.exports = __webpack_public_path__ + "bcd58276f262404811f4c6ffa3aca5aa.svg";